import script from "./HomeArticlesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeArticlesComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeArticlesComponent.vue?vue&type=style&index=0&id=64ca8ce1&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ca8ce1"]])

export default __exports__